export const customerEventSources = {
  confirmBilling: 'confirmBillingAddress'
}
